export default [
  {
    path: "/modules/event/",
    name: "EventPage",
    component: () => import("@/views/modules/event/Event.vue"),
    meta: {
      action: "ROLE_EVENTO_CONSULTAR",
      resource: "ACL",
      pageTitle: "Eventos",
      breadcrumb: [
        {
          text: "Eventos",
        },
      ],
    },
    children: [
      {
        path: "",
        name: "event-list",
        component: () => import("@/views/modules/event/grid/EventGrid.vue"),
        meta: {
          pageTitle: "Eventos",
          action: "ROLE_EVENTO_CONSULTAR",
          resource: "ACL",
          breadcrumb: [
            {
              text: "Módulo Eventos | Eventos",
            },
          ],
        },
      },
      {
        path: "evento-add",
        name: "evento-add",
        component: () => import("@/views/modules/event/EventoForm.vue"),
        meta: {
          pageTitle: "Novo Evento",
          action: "ROLE_EVENTO_CONSULTAR",
          resource: "ACL",
          breadcrumb: [
            { text: "Eventos", route: "event" },
            { text: "Novo Evento", active: true },
          ],
        },
      },
      {
        path: "evento-edit/:id",
        name: "evento-edit",
        component: () => import("@/views/modules/event/EventoForm.vue"),
        meta: {
          pageTitle: "Editar Evento",
          action: "ROLE_EVENTO_CONSULTAR",
          resource: "ACL",
          breadcrumb: [
            { text: "Eventos", route: "event" },
            { text: "Editar Evento", active: true },
          ],
        },
      },
    ],
  },
];
